import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearBreadcrumbFeatures = () => {
  const map = mapAtom.map

  findLayer(map, 'breadcrumbPathAndRoutePolyline').getSource()?.clear()
  findLayer(map, 'breadcrumbPoints').getSource()?.clear()
}
